export default __webpack_public_path__ + "static/media/ArchiveArrowNotificationIcon.31d50e32.svg";